import { render } from "./AppCard.vue?vue&type=template&id=51d8dc6c&ts=true"
import script from "./AppCard.vue?vue&type=script&lang=ts"
export * from "./AppCard.vue?vue&type=script&lang=ts"

import "./AppCard.vue?vue&type=style&index=0&id=51d8dc6c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__